import comp from "./LevelEditor";
export default comp;
